import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';

export default {
  name: 'propertyHistory',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  mixins: [users],
  data: function () {
    return {
      PropHistory: [],
      PropHistoryCols: [],

      TotalRow: 0,
      Pageingoptions: { pageSize: 10, total: 0, page: 1 },
    }
  },
  props: {
    propertyId: {
      type: String,
      required: true
    }
  },
  created() {
    this.configColumns();
  },
  methods: {
    configColumns() {
      this.PropHistoryCols.push({ dataField: 'docNo', caption: this.$t('enquiriesPropertyHistory.docNo') });
      this.PropHistoryCols.push({ dataField: 'details', caption: this.$t('enquiriesPropertyHistory.details') });
      this.PropHistoryCols.push({ dataField: 'date', caption: this.$t('enquiriesPropertyHistory.date'), dataType: 'date' });      
      this.PropHistoryCols.push({ dataField: 'tenantName', caption: this.$t('enquiriesPropertyHistory.tenantName') });
      this.PropHistoryCols.push({ dataField: 'tenantCustkey', caption: this.$t('enquiriesPropertyHistory.tenantAccount') });
      this.PropHistoryCols.push({ dataField: 'ownerCustkey', caption: this.$t('enquiriesPropertyHistory.ownerAccount') });
      this.PropHistoryCols.push({ dataField: 'ownerName', caption: this.$t('enquiriesPropertyHistory.ownerName') });
      this.getData();
    },
    getData() {
      var parameters = {
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.Pageingoptions
      }

      axios.post('/Enquiries/GetPropertyHistory', parameters)
        .then(response => {
          if (response.status == 200) {
            this.PropHistory = response.data.items;

            this.TotalRow = response.data.itemsCount;
            this.$root.$emit(`refresh_data_grid:PropertiesHistDataGrid`);
          }
        })
        .catch(e => {  return false; })
    },
    PageChange(pInfo) {
      this.Pageingoptions.page = pInfo.pageNumber;
      this.Pageingoptions.pageSize = pInfo.pageSize;
      this.getData();
    },

    propSelected(item) {
      //console.log("ududu", item)
    },
  },
}
